// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_kwO","footer":"styles_footer__NRfMY","passCodeTooltip":"styles_passCodeTooltip__3hhdX"};